export default __webpack_public_path__ + "static/gu-97b049b8a8fda578d07cde3957f8daed.svg";